import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@eds-web/react';
import { FormikProps } from 'formik';

interface SaveButtonProps {
    formik: FormikProps<any>;
    updating?: boolean;
}

export const SaveButton: React.FC<SaveButtonProps> = ({ formik, updating = false }) => {
    const { t } = useTranslation();

    const hasMailingAddressFieldsChanged = () => {
        const mailingAddressFields = [
            'mailingAddressLine1',
            'mailingAddressLine2',
            'mailingAddressCity',
            'mailingAddressState',
            'mailingAddressPostCode'
        ];

        return mailingAddressFields.some((field) => {
            const currentValue = formik.values[field];
            const initialValue = formik.initialValues[field];
            return currentValue !== initialValue;
        });
    };

    const hasAddressFieldsChanged = () => {
        const addressFields = [
            'addressLine1',
            'addressLine2',
            'addressCity',
            'addressState',
            'addressPostCode'
        ];

        return addressFields.some((field) => {
            const currentValue = formik.values[field];
            const initialValue = formik.initialValues[field];
            return currentValue !== initialValue;
        });
    };

    const isSubmitDisabled = () => {
        if (!formik.dirty || updating || !formik.isValid) {
            return true;
        }

        if (formik.values.mailingAddressDifferent === true) {
            return !hasMailingAddressFieldsChanged() && !hasAddressFieldsChanged();
        }

        return !hasAddressFieldsChanged();
    };

    return (
        <div className="form-column">
            <Button
                type="submit"
                loadingLabel={t('epic.esport.profile.saving')}
                disabled={isSubmitDisabled()}
                loading={updating}
                variant="cta"
            >
                {t('epic.esport.profile.saveChanges')}
            </Button>
        </div>
    );
};
